import { createDynamicSlice } from ".";
import { getLocationListThunk } from "../thunks/locationsThunk";

export const locationsSlice = createDynamicSlice({
  name: "locations",
  thunk: getLocationListThunk,
  listMode: true,
  resetActionName: "resetLocations",
});

export const locationsReducer = locationsSlice.reducer;
export const { resetLocations } = locationsSlice.actions;
